/**
 * Copyright (c) 2016-present GlossGenius. All rights reserved.
 */

import React from 'react';

import { useGGTheme } from 'hooks/theme/useGGTheme';

import { Book } from './Book';

export function BookContainer() {
  const {
    components: { Layout },
  } = useGGTheme();

  return (
    <Layout>
      <Book />
    </Layout>
  );
}
